/**
 * Explicit Ant Design icons used by templates and ng-zorro (replaces importing all icons).
 * Add new icons here when introducing nz-icon nzType="..." in templates.
 */
import { IconDefinition } from '@ant-design/icons-angular';
import {
  CheckOutline,
  ClearOutline,
  CloseOutline,
  CopyOutline,
  CopyrightOutline,
  DeleteOutline,
  DownloadOutline,
  DownOutline,
  DragOutline,
  EyeInvisibleOutline,
  EyeOutline,
  FileExcelOutline,
  FileOutline,
  FilePdfFill,
  FileTextOutline,
  FilterFill,
  FilterOutline,
  HeartOutline,
  InfoCircleOutline,
  InboxOutline,
  KeyOutline,
  LeftOutline,
  LinkedinFill,
  LinkedinOutline,
  LoadingOutline,
  LogoutOutline,
  MailOutline,
  MenuOutline,
  MinusOutline,
  PlusOutline,
  PrinterOutline,
  QuestionCircleOutline,
  QuestionOutline,
  RightCircleOutline,
  RightOutline,
  RotateRightOutline,
  SafetyCertificateOutline,
  SearchOutline,
  UpOutline,
  ZoomInOutline,
} from '@ant-design/icons-angular/icons';

export const NZ_ICON_DEFINITIONS: IconDefinition[] = [
  CheckOutline,
  ClearOutline,
  CloseOutline,
  CopyOutline,
  CopyrightOutline,
  DeleteOutline,
  DownloadOutline,
  DownOutline,
  DragOutline,
  EyeInvisibleOutline,
  EyeOutline,
  FileExcelOutline,
  FileOutline,
  FilePdfFill,
  FileTextOutline,
  FilterFill,
  FilterOutline,
  HeartOutline,
  InfoCircleOutline,
  InboxOutline,
  KeyOutline,
  LeftOutline,
  LinkedinFill,
  LinkedinOutline,
  LoadingOutline,
  LogoutOutline,
  MailOutline,
  MenuOutline,
  MinusOutline,
  PlusOutline,
  PrinterOutline,
  QuestionCircleOutline,
  QuestionOutline,
  RightCircleOutline,
  RightOutline,
  RotateRightOutline,
  SafetyCertificateOutline,
  SearchOutline,
  UpOutline,
  ZoomInOutline,
];
